/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import DeleteUser from '../components/user/DeleteUser.vue';

/**
 * This component is the main UserManagement page controller.
 *
 * @vue-prop {Object} params the page configuration parameters.
 *
 * @category ui.pages
 * @exports UserManagement
 * @component
 */
const __vue_script__ = {
    name: 'UserManagement',

    components: { SearchBar, Toggler, DeleteUser },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            user: null,
            searchTerm: '',
            usernameNotFound: '',
            usersGlobalRoles: {},
            searchSubmitted: false,
            isCurrentUser: false,
            isCurrentUserSuperAdmin: false
        };
    },

    methods: {
        /**
         * Fetches user from the API
         */
        async fetchUser() {
            try {
                const { data: user } = await this.$services.user.getUser(this.searchTerm);
                const usersGlobalRoles = this.$services.user.getUsersGlobalRoles(user);

                this.user = user;
                this.isCurrentUser = this.$services.user.isCurrentUser(user.name);
                this.isCurrentUserSuperAdmin = this.$services.user.isSuperAdmin();

                this.usernameNotFound = null;

                for (const role of this.$const.GLOBAL_ROLES) {
                    this.$set(this.usersGlobalRoles, role, usersGlobalRoles.includes(role));
                }
            } catch (err) {
                this.user = null;
                this.usersGlobalRoles = {};
                this.usernameNotFound = this.searchTerm;
            } finally {
                this.searchSubmitted = true;
            }
        },

        /**
         * Toggles global role on current user
         */
        async toggleRole(role) {
            try {
                const { data: result } = await this.$services.user.toggleUserGlobalPermission(this.user.name, role);

                if (result && result.ok) {
                    const grantKey = this.usersGlobalRoles[role] ? 'granted' : 'revoked';

                    return this.$notify({
                        group: 'flashes',
                        title: this.$i18n.t(`user_management.grants.success_${grantKey}_title`).toString(),
                        text: this.$i18n.t(`user_management.grants.success_${grantKey}`, [role, this.user.name]).toString(),
                        type: this.usersGlobalRoles[role] ? 'success' : 'warn'
                    });
                }
            } catch (err) {
                console.error('[UserManagement] Error occurred while toggling the user role.', err);
            }

            // Restore previous status
            this.$set(this.usersGlobalRoles, role, !this.usersGlobalRoles[role]);

            this.$notify({
                group: 'flashes',
                title: this.$i18n.t('user_management.grants.failed_title').toString(),
                text: this.$i18n.t('user_management.grants.failed', [role, this.user.name]).toString(),
                type: 'error'
            });
        },

        /**
         * Check if given role is superadmin
         */
        isSuperadminRole(role) {
            return role === this.$const.ROLE_SUPERADMIN;
        },

        /**
         * Refetch user on delete
         */
        onDeleted() {
            this.fetchUser();
        }
    }

};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    attrs: { slim: "slim" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var handleSubmit = ref.handleSubmit
          return [
            _c(
              "form",
              {
                staticClass: "user-management",
                attrs: { autocomplete: "off" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.fetchUser)
                  },
                },
              },
              [
                _c("h1", [_vm._v(_vm._s(_vm.$t("user_management.title")))]),
                _c(
                  "search-bar",
                  {
                    attrs: {
                      rules: "email",
                      results: _vm.user,
                      "show-no-result": _vm.searchSubmitted,
                    },
                    on: {
                      input: function ($event) {
                        _vm.searchSubmitted = false
                      },
                    },
                    model: {
                      value: _vm.searchTerm,
                      callback: function ($$v) {
                        _vm.searchTerm = $$v
                      },
                      expression: "searchTerm",
                    },
                  },
                  [
                    _c("button", { staticClass: "btn primary" }, [
                      _vm._v(_vm._s(_vm.$t("user_management.search"))),
                    ]),
                  ]
                ),
                _vm.user && _vm.user.roles.length
                  ? _c("div", { staticClass: "user-details" }, [
                      _c("h2", [
                        _vm._v(
                          _vm._s(_vm.user.realname) +
                            " (" +
                            _vm._s(_vm.user.email) +
                            ")"
                        ),
                      ]),
                      _c("div", { staticClass: "table-wrapper" }, [
                        _c("table", { staticClass: "table-striped" }, [
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.usersGlobalRoles,
                              function (hasRole, role) {
                                return _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "checker" },
                                    [
                                      _c("toggler", {
                                        attrs: {
                                          disabled:
                                            _vm.isSuperadminRole(role) &&
                                            (!_vm.isCurrentUserSuperAdmin ||
                                              _vm.isCurrentUser),
                                          name: role,
                                          "off-label": "",
                                          "on-label": "",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.toggleRole(role)
                                          },
                                        },
                                        model: {
                                          value: _vm.usersGlobalRoles[role],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.usersGlobalRoles,
                                              role,
                                              $$v
                                            )
                                          },
                                          expression: "usersGlobalRoles[role]",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "user_management.roles." +
                                              _vm.$utils.strings.sanitizeTranslationKey(
                                                role
                                              )
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("td", { staticClass: "actions" }, [
                                    _c("code", [_vm._v(_vm._s(role))]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "user_management.grants." +
                                              (hasRole ? "granted" : "denied")
                                          )
                                        )
                                    ),
                                  ]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.user
                  ? _c("delete-user", {
                      attrs: {
                        "can-delete":
                          _vm.isCurrentUserSuperAdmin && !_vm.isCurrentUser,
                        user: _vm.user,
                      },
                      on: { deleted: _vm.onDeleted },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/UserManagement.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__